export default "__VITE_ASSET__BawkyhgL__"